/**
 * API Service - Cliente HTTP genérico para todas as chamadas à API
 *
 * Use este serviço para fazer requisições autenticadas à API.
 * O token JWT é adicionado automaticamente via interceptor.
 *
 * Exemplo de uso:
 *
 * import { api } from '@/services/api';
 *
 * const response = await api.get('/videos/get/123');
 * const data = await api.post('/videos/upload', videoData);
 */

import { authApi } from './authService';

export const api = {
  /**
   * GET request
   */
  get: async <T = any>(url: string, config?: any) => {
    const response = await authApi.get<T>(url, config);
    return response.data;
  },

  /**
   * POST request
   */
  post: async <T = any>(url: string, data?: any, config?: any) => {
    const response = await authApi.post<T>(url, data, config);
    return response.data;
  },

  /**
   * PUT request
   */
  put: async <T = any>(url: string, data?: any, config?: any) => {
    const response = await authApi.put<T>(url, data, config);
    return response.data;
  },

  /**
   * PATCH request
   */
  patch: async <T = any>(url: string, data?: any, config?: any) => {
    const response = await authApi.patch<T>(url, data, config);
    return response.data;
  },

  /**
   * DELETE request
   */
  delete: async <T = any>(url: string, config?: any) => {
    const response = await authApi.delete<T>(url, config);
    return response.data;
  },
};

export default api;
